//generic error page
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("React error caught:", error, errorInfo);
    // You could log to an error reporting service here too
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h1>500 - Something went wrong.</h1>
          <p>Try refreshing the page or check back later.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
